import { router } from '@inertiajs/vue3'

const META_PIXEL_SCRIPT_SELECTOR = 'script[data-meta-pixel="true"]'

const isInvestorAppHost = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  return window.location.hostname === 'app.finesthub.de'
}

const isGuestPage = (component: string): boolean => {
  return !component.startsWith('investors/') && !component.startsWith('banks/') && !component.startsWith('export/')
}

const ensureScript = (): void => {
  if (document.querySelector(META_PIXEL_SCRIPT_SELECTOR)) {
    return
  }

  const scriptElement = document.createElement('script')
  scriptElement.async = true
  scriptElement.src = 'https://connect.facebook.net/en_US/fbevents.js'
  scriptElement.dataset.metaPixel = 'true'
  document.head.appendChild(scriptElement)
}

const ensureFbq = (): void => {
  if (window.fbq) {
    return
  }

  const fbq: FbqFunction = function (...args: unknown[]): void {
    if (typeof fbq.callMethod === 'function') {
      fbq.callMethod(...args)
      return
    }

    fbq.queue.push(args)
  }

  fbq.callMethod = undefined
  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = (...args: unknown[]) => fbq(...args)

  window.fbq = fbq
  window._fbq = fbq
}

const track = (...args: unknown[]): void => {
  if (!window.fbq) {
    return
  }

  window.fbq(...args)
}

export const trackMetaRegistration = (eventId: string): void => {
  if (!isInvestorAppHost()) {
    return
  }

  track('track', 'CompleteRegistration', {}, { eventID: eventId })
}

export default (initialComponent: string, pixelIds: string[]): void => {
  if (!isInvestorAppHost() || pixelIds.length === 0) {
    return
  }

  ensureFbq()
  ensureScript()

  pixelIds.forEach((pixelId) => track('init', pixelId))

  if (isGuestPage(initialComponent)) {
    track('track', 'PageView')
  }

  router.on('navigate', (event) => {
    if (!isGuestPage(event.detail.page.component)) {
      return
    }

    track('track', 'PageView')
  })
}
